import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useBindApplication } from "../../useBindApplication";
import * as ApplicationStandAloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import { useSubjectPropertyFieldBindings } from "./useSubjectPropertyFieldBindings";
import { computed } from "@vue/composition-api";
import { useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
export const useSubjectPropertyHelpers = () => {
  const {
    addNestedField,
    removeNestedField
  } = useBindApplication();
  const {
    RESET_SUBJECT_PROPERTY_EXISTING_MORTGAGES
  } = useApplicationStandaloneStoreMutations([ApplicationStandAloneMutations.RESET_SUBJECT_PROPERTY_EXISTING_MORTGAGES]);
  const {
    subjectProperty
  } = useSubjectPropertyFieldBindings();
  const {
    currentFlow
  } = useSummaryHelpers();
  const showSubjectPropertyExistingMortgages = computed(() => {
    var _context;
    return _includesInstanceProperty(_context = ["refinance-approval", "switch-transfer"]).call(_context, currentFlow.value);
  });
  const propertyHasExistingMortgages = computed(() => {
    var _ref, _subjectProperty$valu, _subjectProperty$valu2;
    return (_ref = ((_subjectProperty$valu = subjectProperty.value) == null ? void 0 : _subjectProperty$valu["existing-mortgages"]) && !!((_subjectProperty$valu2 = subjectProperty.value) != null && _subjectProperty$valu2["existing-mortgages"].length)) != null ? _ref : false;
  });
  const allSubjectPropertyExistingMortgages = computed(() => {
    var _subjectProperty$valu3, _subjectProperty$valu4;
    return (_subjectProperty$valu3 = (_subjectProperty$valu4 = subjectProperty.value) == null ? void 0 : _subjectProperty$valu4["existing-mortgages"]) != null ? _subjectProperty$valu3 : [];
  });
  const addExistingMortgage = () => {
    addNestedField("[property][existing-mortgages]");
  };
  const deleteExistingMortgage = existingMortgageIndex => {
    removeNestedField("[property][existing-mortgages]", existingMortgageIndex);
  };
  const handleChangeIsThePropertyStillMortgaged = value => {
    if (value) {
      addExistingMortgage();
    } else {
      RESET_SUBJECT_PROPERTY_EXISTING_MORTGAGES();
    }
  };
  return {
    propertyHasExistingMortgages,
    showSubjectPropertyExistingMortgages,
    addExistingMortgage,
    deleteExistingMortgage,
    handleChangeIsThePropertyStillMortgaged,
    allSubjectPropertyExistingMortgages
  };
};